/* eslint-disable @typescript-eslint/no-explicit-any */
import { SseStatus, SseEvents } from '../states';

export const Sse = (data: any) => {
  const source: any = new EventSource(`${data.url}`);

  // Event Handlers
  source.onopen = () => {
    data.setError(false);
    data.setStatus(SseStatus.open);
  };

  source.onmessage = (event: any) => {
    console.log('Onmessage: ', event);
  };

  Object.values(SseEvents).forEach((item) => {
    source.addEventListener(item, (event: any) => {
      data.dispatchResults(event);
      if (event.type === SseEvents.OPERATION_FINISHED)
        data.setIsOperationFinished(true);
    });
  });

  source.onerror = () => {
    if (source.readyState === EventSource.CLOSED) {
      data.toastError();
      data.setStatus(SseStatus.error);
      data.setError(true);
      source.close();
    } else {
      data.setStatus(SseStatus.closed);
      source.close();
    }
  };

  return source;
};
